/* MONOM, scheda prodotto (2026-10-13).

   1. "Dettaglio" nella riga omaggio: apre e chiude il riquadro con la foto.
      La riga stessa la riscrive il tema a ogni cambio formato (e' un blocco
      con data-update-id), quindi qui basta un ascoltatore sul documento.
   2. "Aggiunto" per 1,5 secondi prima che si apra il carrello laterale.
   3. Invito chat in riga: stessa apertura della chat dell'invito lungo, con
      ripiego sul link /pages/contattaci.
   4. Bottone fisso in basso (solo telefono): copia dello stesso bottone, non un
      secondo modulo. Un clic sulla copia fa il clic sul bottone vero. */
(function(){
  'use strict';

  /* ---------- 1. Dettaglio ---------- */
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest ? e.target.closest('[data-mnom-apri]') : null;
    if (!b) return;
    var box = b.closest('.mnom');
    var det = box && box.querySelector('[data-mnom-dettaglio]');
    if (!det) return;
    var aperto = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', aperto ? 'false' : 'true');
    if (aperto) det.setAttribute('hidden', ''); else det.removeAttribute('hidden');
  });

  /* ---------- 1b. Riga omaggio al cambio formato ----------
     Il tema potrebbe non rimpiazzare il blocco: si legge la riga dai data-attribute
     scritti in Liquid per ogni variante. Se la variante non ha dati, la riga si spegne. */
  function aggiornaOmaggio(id){
    var box = document.querySelector('[data-mnom]');
    if (!box) return;
    var d = null, el = box.querySelectorAll('[data-mnom-var]');
    for (var i = 0; i < el.length; i++) if (el[i].getAttribute('data-mnom-var') === String(id)) d = el[i];
    var riga = box.querySelector('[data-mnom-riga]'), det = box.querySelector('[data-mnom-dettaglio]');
    if (!d) {
      riga.hidden = true; det.hidden = true;
      var ap = riga.querySelector('[data-mnom-apri]'); if (ap) ap.setAttribute('aria-expanded', 'false');
      return;
    }
    riga.hidden = false; det.hidden = false;
    box.querySelector('[data-mnom-testo]').textContent = d.getAttribute('data-riga');
    box.querySelector('[data-mnom-titolo]').textContent = d.getAttribute('data-titolo');
    var img = box.querySelector('[data-mnom-img]');
    img.src = d.getAttribute('data-img') || ''; img.alt = d.getAttribute('data-titolo');
  }
  document.addEventListener('change', function(e){
    var r = e.target;
    if (!r || !r.matches || !r.matches('input[data-product-variant]')) return;
    /* solo il form della scheda principale, non prodotti in evidenza o quick view */
    if (!r.closest('product-information, .product-details-wrapper')) return;
    var w = r.closest('[data-swatch-variant-id]');
    var id = w && w.getAttribute('data-swatch-variant-id');
    if (id) aggiornaOmaggio(id); /* id mancante: la riga non si tocca */
  });

  /* ---------- 2. "Aggiunto" 1,5 s, poi il carrello laterale ---------- */
  var inAggiunta = false, timerAgg = 0;
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[data-type="add-to-cart-form"]')) return;
    inAggiunta = true;
    clearTimeout(timerAgg);
    timerAgg = setTimeout(function(){ inAggiunta = false; }, 8000);
  }, true);

  function agganciaEventBus(){
    var eb = window.eventBus;
    if (!eb || typeof eb.emit !== 'function') return false;
    if (!window.matchMedia || !matchMedia('(max-width:749px)').matches) return true; /* desktop: carrello come prima */
    if (eb.__mnAgg) return true;
    eb.__mnAgg = true;
    var originale = eb.emit;
    eb.emit = function(nome){
      var args = arguments, self = this;
      if (nome === 'open:cart:drawer' && inAggiunta) {
        inAggiunta = false;
        var tx = document.querySelector('.mn-carrello [data-add-to-cart-text]');
        var ag = document.querySelector('.mn-carrello [data-cart-added-text]');
        if (tx && ag) {
          tx.style.display = 'none';
          ag.style.display = 'block';
          setTimeout(function(){
            ag.style.display = 'none';
            tx.style.display = 'block';
            originale.apply(self, args);
          }, 1500);
          return;
        }
      }
      return originale.apply(self, args);
    };
    return true;
  }
  (function riprova(n){ if (!agganciaEventBus() && n < 40) setTimeout(function(){ riprova(n + 1); }, 250); })(0);

  /* ---------- 3. Invito chat in riga ---------- */
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('[data-mn-chat]') : null;
    if (!a) return;
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var host = document.querySelector('shopify-chat');
    if (!host) return; /* nessuna chat: segue il link */
    var vai = function(){ window.location.href = a.getAttribute('href'); };
    e.preventDefault();
    try {
      host.setAttribute('data-mn-pronto', '');
      if (window.getComputedStyle(host).display === 'none') {
        host.style.setProperty('display', 'grid', 'important');
        new MutationObserver(function(_, mo){
          if (!host.hasAttribute('open')) { host.style.removeProperty('display'); mo.disconnect(); }
        }).observe(host, {attributes: true, attributeFilter: ['open']});
      }
      if (typeof host.show === 'function') host.show();
      else if ('open' in host) host.open = true;
      else host.setAttribute('open', '');
      if (!host.hasAttribute('open') && host.shadowRoot) {
        var att = host.shadowRoot.querySelector('.activator');
        if (att) att.click();
      }
    } catch (err) {}
    var n = 0;
    (function controlla(){
      if (host.hasAttribute('open') && window.getComputedStyle(host).display !== 'none') return;
      if (++n > 8) return vai();
      setTimeout(controlla, 150);
    })();
  });

  /* ---------- 4. Bottone fisso ---------- */
  function avviaFisso(){
    if (!document.body.classList.contains('template-product')) return;
    /* a larghezza da telefono soltanto */
    if (!window.matchMedia || !matchMedia('(max-width:749px)').matches) return;
    var vero = null, ioVero = null, fuori = false, fondo = false;
    var barra = document.createElement('div');
    barra.className = 'mn-fisso';
    barra.setAttribute('aria-hidden', 'true');
    barra.innerHTML = '<button type="button" class="mn-fisso__btn" tabindex="-1">' +
      '<span class="mn-fisso__etichetta"></span><span class="mn-fisso__prezzo"></span></button>';
    document.body.appendChild(barra);
    var bott = barra.firstChild, etichetta = bott.children[0], prezzo = bott.children[1];

    function trovaVero(){ return document.querySelector('.mn-carrello .product--add-to-cart-button'); }

    function testoVisibile(b){
      var spans = b.querySelectorAll('[data-cart-added-text], .mn-btn__aggiungo, [data-add-to-cart-text]');
      for (var i = 0; i < spans.length; i++) {
        var cs = getComputedStyle(spans[i]);
        if (cs.display !== 'none') return spans[i].textContent.replace(/\s+/g, ' ').trim();
      }
      return '';
    }

    /* si scrive solo se il valore cambia: niente mutazioni inutili, niente cicli */
    function scrivi(el, v){ if (el.textContent !== v) el.textContent = v; }

    function specchia(){
      if (!vero) return;
      var p = vero.querySelector('[data-mn-prezzo]');
      scrivi(etichetta, testoVisibile(vero));
      scrivi(prezzo, p ? p.textContent.replace(/\s+/g, ' ').trim() : '');
      if (bott.disabled !== vero.disabled) bott.disabled = vero.disabled;
      bott.classList.toggle('mn-esaurito', vero.classList.contains('mn-esaurito'));
    }

    function altroAperto(){
      var b = document.body;
      if (/(^|\s)(drawer-open|modal-open|overflow-hidden|theme-modal-open)(\s|$)/.test(b.className || '')) return true;
      if (document.querySelector('.mnp.mnp--aperto')) return true;
      var ck = document.getElementById('shopify-pc__banner');
      if (ck && ck.checkVisibility && ck.checkVisibility()) return true;
      if (ck && !ck.checkVisibility && ck.offsetHeight > 0) return true;
      return false;
    }

    function aggiorna(){
      var acceso = fuori && !fondo && !altroAperto();
      barra.classList.toggle('is-on', acceso);
      document.body.classList.toggle('mn-fisso-on', acceso);
      barra.setAttribute('aria-hidden', acceso ? 'false' : 'true');
      bott.tabIndex = acceso ? 0 : -1;
      specchia();
    }

    function osservaVero(){
      var nuovo = trovaVero();
      if (nuovo === vero) return;
      if (ioVero) ioVero.disconnect();
      vero = nuovo;
      if (!vero) { fuori = false; aggiorna(); return; }
      ioVero = new IntersectionObserver(function(voci){
        var r = voci[voci.length - 1];
        /* "fuori" solo se il bottone e' uscito dal bordo alto, non se e' ancora sotto */
        fuori = !r.isIntersecting && r.boundingClientRect.top < 0;
        aggiorna();
      });
      ioVero.observe(vero);
    }

    var footer = document.querySelector('footer.site-footer, .footer-wrapper, footer');
    if (footer) {
      new IntersectionObserver(function(voci){
        fondo = voci[voci.length - 1].isIntersecting;
        aggiorna();
      }).observe(footer);
    }

    var inAttesa = false;
    function pianifica(){
      if (inAttesa) return;
      inAttesa = true;
      requestAnimationFrame(function(){ inAttesa = false; osservaVero(); aggiorna(); });
    }
    /* si osserva il solo form prodotto (la barra fissa sta fuori, sul body);
       il body per i cambi di classe (carrello aperto) senza sottoalbero */
    var zona = document.querySelector('product-information, .product-details-wrapper') || document.querySelector('main');
    var opz = { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'disabled', 'hidden'] };
    if (zona) new MutationObserver(pianifica).observe(zona, opz);
    new MutationObserver(pianifica).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', pianifica);

    bott.addEventListener('click', function(){
      if (vero && !vero.disabled) vero.click();
    });
    osservaVero();
    aggiorna();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avviaFisso);
  else avviaFisso();
})();

/* MONOM, opzioni Mageworx (Tris e simili): quando si cambia formato il tema
   riscarica il blocco del prodotto e cancella le tendine dell'app, che non le
   rimette. Se la pagina aveva le tendine e dopo il cambio non ci sono piu',
   si ricarica la pagina sul formato scelto: caricata cosi' l'app le disegna
   giuste. Sui prodotti senza opzioni Mageworx non fa niente. */
(function(){
  var visto = false;
  function guarda(){ if (document.querySelector('.mw-apo-container')) visto = true; }
  function avvia(){
    guarda();
    if (window.MutationObserver) {
      var mo = new MutationObserver(guarda);
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function(){ mo.disconnect(); }, 20000);
    }
    if (!window.eventBus || !window.eventBus.on) return;
    window.eventBus.on('variant:updated', function(){
      setTimeout(function(){
        if (visto && !document.querySelector('.mw-apo-container')) window.location.reload();
      }, 400);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
